import * as Yup from 'yup';

import { URL_REGEX } from '../..';
import { getI18nErrorMessage } from '../../i18n';

export const URL_VALIDATION_SCHEMA = Yup.string().matches(
  URL_REGEX,
  getI18nErrorMessage('core.error.url.notMatch')
);
